<script setup>
import useAttributes from "../../use/useAttributes"

import { ref, onUpdated, onMounted, computed, defineProps, defineEmits } from "vue"
import vSelect from "vue-select"
import "vue-select/dist/vue-select.css"

import store from "../../state/store"

const props = defineProps({
  modelValue: Boolean,
  attribute: {
    required: true,
    type: Object,
  },
  allCategories: {
    required: true,
    type: Object,
  },
})

const attributeData = ref({
  id: props.attribute.id,
  category_id: props.attribute.category_id,
  attribute_name: props.attribute.name,
  attribute_displayname: props.attribute.display_name,
})

const emit = defineEmits(["update:modelValue", "close"])

const { show, loading, errors, onSubmit, closeModal } = useAttributes(
  props,
  emit,
  attributeData
)

onUpdated(() => {
  attributeData.value = {
    id: props.attribute.id,
    category_id: props.attribute.category_id,
    attribute_name: props.attribute.name,
    attribute_displayname: props.attribute.display_name,
  }
})

onMounted(() => {
  store.dispatch("getAllCategories")
})

const levelThreeCategories = computed(() => {
 
 const categories = props.allCategories.data || [];
 return categories.filter(category => {
   const parentCategory = categories.find(
     parent => parent.id === category.parent_id
   );
   return parentCategory && parentCategory.parent_id !== null;
 });
});
</script>

<template>
  <!-- add and edit attribute modal  -->
  <b-modal
    v-model="show"
    @close="closeModal()"
    id="showModal"
    hide-footer
    title=" ویرایش ویژگی"
    header-class="p-3 bg-light"
    class="v-modal-custom"
    centered
    no-close-on-backdrop
  >
    <b-overlay
      variant="white"
      opacity="0.75"
      blur="2px"
      :show="loading"
      spinner-variant="success"
      rounded="sm"
    >
      <b-card>
        <b-form
          id="addform"
          class="tablelist-form"
          autocomplete="off"
          @submit.prevent="onSubmit"
          enctype="multipart/form-data"
        >
          <div class="mb-3">
            <label for="name" class="form-label">دسته بندی </label>

            <v-select
              v-model="attributeData.category_id"
              :options="levelThreeCategories"
              label="name"
              :reduce="(category) => category.id"
              placeholder="جستجوی دسته‌بندی"
              class="mb-3 v-select-rtl"
            />

            <div v-if="errors">
              <div class="invalid-feedback" v-if="errors.category_id">
                <span>{{ errors.category_id[0] }}</span>
              </div>
            </div>
          </div>

          <div class="mb-3">
            <label for="name" class="form-label"> نام ویژگی</label>
            <input
              type="text"
              id="name"
              class="form-control"
              placeholder="نام ویژگی"
              v-model="attributeData.attribute_name"
            />
            <div v-if="errors">
              <div class="invalid-feedback" v-if="errors.attribute_name">
                <span>{{ errors.attribute_name[0] }}</span>
              </div>
            </div>
          </div>

          <div class="mb-3">
            <label for="slug" class="form-label">نام نمایشی</label>
            <input
              type="text"
              id="slug"
              class="form-control"
              placeholder="لینک دسته بندی"
              v-model="attributeData.attribute_displayname"
            />
            <div v-if="errors">
              <div class="invalid-feedback" v-if="errors.attribute_displayname">
                <span>{{ errors.attribute_displayname[0] }}</span>
              </div>
            </div>
          </div>

          <div class="hstack gap-2 justify-content-end">
            <b-button
              type="button"
              id="closemodal"
              variant="light"
              @click="closeModal"
            >
              بستن
            </b-button>
            <b-button type="submit" variant="success">ویرایش ویژگی</b-button>
          </div>
        </b-form>
      </b-card>
    </b-overlay>
  </b-modal>
</template>
